import React from "react";
import { Modal, Divider, Form, Button } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { Input } from "antd";
import { useDispatch } from "react-redux";

const { TextArea } = Input;

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
    "&:hover": {
      backgroundColor: "#EF4667",
      color: "#fff",
    },
  },
}));

const NotesModal = ({ open, setOpen }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const handleSubmit = (values) => {
    console.log(values);
    dispatch({
      type: "SET_NOTES",
      payload: values.notes,
    });
    setOpen(false);
    form.resetFields();
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={false}
      centered
      className={classes.modalStyle}
      width={500}
      getContainer={false}
    >
      <h3
        style={{
          color: "#EF4667",
        }}
      >
        Notes
      </h3>
      <Divider className={classes.dividerStyle} />
      <Form
        labelCol={{
          span: 24,
        }}
        form={form}
        wrapperCol={{
          span: 24,
        }}
        onFinish={handleSubmit}
      >
        <Form.Item
          name={"notes"}
          rules={[
            {
              required: true,
              message: "Notes should not be empty",
            },
          ]}
        >
          <TextArea showCount maxLength={150} style={{ height: 120 }} />
        </Form.Item>
        <div
          style={{
            textAlign: "right",
            marginTop: "8px",
          }}
        >
          <Button size="large" onClick={handleClose} type="link">
            Cancel
          </Button>
          <Button
            size="large"
            htmlType="submit"
            style={{
              marginLeft: "16px",
            }}
            className={classes.ButtonStyle}
          >
            Submit
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default NotesModal;
